import { ICONS, accentOf } from "@/components/layers";
import { Field, SelectField } from "@/components/editor/fields";

const SWATCHES = ["#A62B8A", "#3D3DF0", "#A33AF0", "#1683F5", "#16B8A6", "#45EBC0", "#5FA82E", "#F7933E", "#EF4444", "#0F172A", "#FFFFFF"];
const IDLE = [["glow", "Glow pulse"], ["breathe", "Breathe"], ["bounce", "Bounce"], ["wobble", "Wobble"], ["none", "Still"]];
const HOVER = [["lift", "Lift & glow"], ["wiggle", "Wiggle"], ["spin", "Spin"], ["glow", "Brighten"], ["none", "None"]];
const ICON_TYPES = { hotspot: (l) => ["pulse", "icon"].includes(l.style || "pulse"), popup: (l) => l.style !== "invisible", audio: () => true };

const ColorField = ({ l, set }) => {
  const c = accentOf(l);
  return (
    <Field label="Colour">
      <div className="flex flex-wrap items-center gap-1.5" data-testid="prop-accent">
        {SWATCHES.map((s) => (
          <button key={s} type="button" onClick={() => set({ accent: s })} aria-label={`Colour ${s}`} data-testid={`prop-accent-${s.slice(1)}`}
            className={`h-6 w-6 rounded-full border border-black/10 transition-transform hover:scale-110 ${c.toLowerCase() === s.toLowerCase() ? "ring-2 ring-[#3D3DF0] ring-offset-2 ring-offset-[#EEF2F8]" : ""}`} style={{ background: s }} />
        ))}
        <label className="relative grid h-6 w-6 cursor-pointer place-items-center overflow-hidden rounded-full border border-dashed border-[#94A3B8] text-[10px] font-bold text-[#64748B]" title="Custom colour">
          +<input type="color" value={c.length === 7 ? c : "#3D3DF0"} onChange={(e) => set({ accent: e.target.value })} className="absolute inset-0 cursor-pointer opacity-0" data-testid="prop-accent-custom" />
        </label>
      </div>
    </Field>
  );
};

const IconField = ({ l, set }) => (
  <Field label="Icon">
    <div className="grid grid-cols-8 gap-1" data-testid="prop-icon-picker">
      <button type="button" onClick={() => set({ iconName: "" })} className={`h-7 rounded-lg text-[9px] font-bold ${!l.iconName ? "neu-btn-primary" : "neu-btn text-[#64748B]"}`} data-testid="prop-icon-auto">Auto</button>
      {Object.entries(ICONS).map(([k, I]) => (
        <button key={k} type="button" onClick={() => set({ iconName: k })} aria-label={`Icon ${k}`} title={k} data-testid={`prop-icon-${k}`}
          className={`grid h-7 place-items-center rounded-lg transition-transform hover:scale-110 ${l.iconName === k ? "neu-btn-primary" : "neu-btn text-[#334155]"}`}><I className="h-3.5 w-3.5" /></button>
      ))}
    </div>
  </Field>
);

export const AppearanceFields = ({ l, set }) => (
  <>
    <ColorField l={l} set={set} />
    {ICON_TYPES[l.type]?.(l) && <IconField l={l} set={set} />}
    <div className="grid grid-cols-2 gap-2">
      <SelectField label="Idle motion" value={l.idle || "glow"} onChange={(v) => set({ idle: v })} options={IDLE} testid="prop-idle" />
      <SelectField label="On hover" value={l.hover || "lift"} onChange={(v) => set({ hover: v })} options={HOVER} testid="prop-hover" />
    </div>
    <p className="text-[10px] text-[#94A3B8]">Idle motion keeps the icon gently moving, so readers can see it's clickable even without hovering.</p>
  </>
);
